import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { CaretDown, CaretRight, Icon, X } from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";

export const StatusBar = ({
  isShowing,
  icon,
  caption,
  actionPayload,
  showCloseButton = false,
  onClose,
  isExpanded = false,
  childComponent = () => <></>,
  childComponentProps = {},
  className = "",
}: {
  isShowing: boolean;
  icon?: Icon;
  caption: string | React.ReactNode;
  actionPayload: any;
  showCloseButton: boolean;
  onClose: () => void;
  isExpanded: boolean;
  children: React.ReactNode;
  childComponent: (props: any) => React.ReactNode;
  childComponentProps: any;
  className?: string;
}) => {
  const [barIsExpanded, setBarIsExpanded] = useState(isExpanded);

  useEffect(() => {
    setBarIsExpanded(isExpanded);
  }, [isExpanded]);


  if (!isShowing) return null;

  return (
    <div className={`mb-[-23px] mt-[-20px] pb-[30px] bg-black/10 dark:bg-white/10 hover:bg-black/20 dark:hover:bg-white/20 border-none rounded-t-2xl pt-2 px-3 appearance-none focus:outline-none focus:ring-0 peer cursor-pointer ${className}`} onClick={() => setBarIsExpanded(!barIsExpanded)}> {/* bg-yellow-500 */}
      <div className="flex justify-between items-center">
        <div className="flex gap-1 items-center">
          {/* {icon && React.cloneElement(icon, { size: 14, className: "text-black/50 dark:text-white/50" })} */}
          {/* {isExpanded ? <CaretDown size={14} className="text-black/50 dark:text-white/50" /> : <CaretRight size={14} className="text-black/50 dark:text-white/50" />} */}
          {icon && React.createElement(icon, { size: 14, className: "text-black/50 dark:text-white/50" })}
          <p className="text-[11pt]">{caption}</p>
        </div>

        <div className="flex gap-1 items-center">
          {actionPayload && (
            <Button
              type={ButtonTypes.SOFT}
              className="py-2 text-md"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                actionPayload.onClick();
              }}
              label={<span className="text-[11pt]">{actionPayload.label}</span>}
            />
          )}

          {showCloseButton && (
            <button
              className="px-1 dark:text-white/50 text-black/50 hover:dark:text-black/10 hover:text-white/10"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                e.preventDefault();
                onClose();
              }}
            >
              <X size={14} />
            </button>
          )}
        </div>
      </div>

      {barIsExpanded && childComponent && (
        <div>{React.createElement(childComponent, childComponentProps)}</div>
      )}
    </div>
  );
};
